import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  iconfont: "md",
  theme: {
    themes: {
      light: {
        primary: {
          base: "#FF7F7E",
          lighten1: "#FFB1AD",
        },
        secondary: {
          base: "#5D6B70",
          lighten1: "#5C6B70",
        },
        accent: "#8c9eff",
        error: {
          base: "#FF3F3A",
          lighten1: "#FFE1E0",
        },
      },
    },
  },
});
